var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEcoLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_145_2916",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_145_2916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.22655 20.3825C4.07552 20.2314 4 20.041 4 19.8111C4 19.5813 4.07552 19.392 4.22655 19.2433L6.09373 17.3762C5.51191 16.6657 5.05841 15.8693 4.73323 14.9871C4.40805 14.105 4.24545 13.1698 4.24545 12.1818C4.24545 9.89769 5.03807 7.96305 6.62331 6.37783C8.20853 4.79261 10.1432 4 12.4272 4H18.9517C19.4119 4 19.8031 4.16118 20.1255 4.48354C20.4478 4.80593 20.609 5.19718 20.609 5.65731V12.1818C20.609 14.4659 19.8164 16.4005 18.2312 17.9857C16.646 19.5709 14.7113 20.3636 12.4272 20.3636C11.4394 20.3636 10.5089 20.201 9.63566 19.8758C8.76246 19.5506 7.97062 19.0971 7.26013 18.5153L5.36568 20.3825C5.21697 20.5335 5.0277 20.609 4.79786 20.609C4.56805 20.609 4.37761 20.5335 4.22655 20.3825ZM8.65524 15.9521C8.80627 16.1267 8.99628 16.2106 9.22526 16.2039C9.45423 16.1972 9.64952 16.1139 9.81114 15.9538L14.093 11.6825C14.2622 11.5132 14.3468 11.3188 14.3468 11.0993C14.3468 10.8797 14.2633 10.6864 14.0961 10.5192C13.943 10.3661 13.7515 10.2895 13.5216 10.2895C13.2918 10.2895 13.1026 10.365 12.9538 10.5161L8.65524 14.8146C8.50418 14.964 8.42865 15.1506 8.42865 15.3745C8.42865 15.5985 8.50418 15.791 8.65524 15.9521Z",
    fill: "#72D270"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcoLeaf);
export default __webpack_public_path__ + "static/media/eco_leaf.f46dec10e50f999765fadb3a388aded4.svg";
export { ForwardRef as ReactComponent };